const strings = {
  app: {
    name: "La pénztárgép"
  }
};
export default strings;
